
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { updatePIDiscountAndProfit } from "@/api/proforma";
import { deepClone } from "@/utils/deepClone";
import {
  getHeaderInfo,
  getDeliveryVerificationList,
  resetAmount,
  updateAmount,
  getModelType,
  updateModel,
  getUpdateModel,
} from "@/api/purchase-order";

@Component({
  name: "ModifyNumber",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private isEdit: boolean;
  @Prop({ default: [] }) private selectedList: [] | any;
  @Prop({ default: [] }) private modelType: [] | any;
  @Prop({ default: "" }) private inquirySheetId: "";
  @Prop({ default: "" }) private type: "";
  private form = {
    saleDiscount: null,
    purchaseDiscount: null,
  };
  private title = "";
  private newSelectedRows: any[] = [];

  @Watch("show", { immediate: true })
  private async watchShow() {
    console.log('走了show')
    if(this.show) {
      this.newSelectedRows = deepClone(this.selectedList);
      if(this.newSelectedRows.length > 0 && this.type !== "") {
        await this.getUpdateModel();
      }
    }
  }

  // @Watch("selectedList", { immediate: true })
  // private async watchData() {
  //   console.log('走了selectedList')
  //   if(this.show) {
  //     this.newSelectedRows = deepClone(this.selectedList);
  //     if(this.newSelectedRows.length > 0 && this.type !== "") {
  //       await this.getUpdateModel();
  //     }
  //   }
  // }

  @Watch("type", { immediate: true })
  private async watchType() {
    console.log('走了type')
    this.title = `修改${
      this.modelType.find((item: any) => item.name === this.type).desc
    }`;
  }

  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {
      label: "采购订单型号",
      prop: "poModel",
      key: "poModel",
      show: true,
      disabled: false,
    },
    {
      label: "装箱单型号",
      prop: "originalModel",
      key: "originalModel",
      show: true,
      disabled: false,
    },
    {
      label: "修改后型号",
      prop: "model",
      key: "model",
      show: true,
      type: "input",
    },
    {
      label: "匹配结果",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "√",
          key: "matched",
          value: true,
          click: "",
          color: "color-black",
        },
        {
          name: "×",
          key: "matched",
          value: false,
          click: "",
          color: "color-black",
        },
      ],
    },
  ] as any;
  private list = [
    {
      label: "采购折扣",
      prop: "purchaseDiscount",
      key: "purchaseDiscount",
      type: "input",
      placeholder: "请输入采购折扣",
      clearable: true,
      maxlength: 100,
      unit: "%",
      rules: {
        required: true,
        message: "请输入采购折扣",
        trigger: "change",
      },
    },
    {
      label: "销售折扣",
      prop: "saleDiscount",
      key: "saleDiscount",
      type: "input",
      unit: "%",
      placeholder: "请输入销售折扣",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请输入销售折扣",
        trigger: "change",
      },
    },
  ];

  private close() {
    this.$emit("update:show", false);
    this.$emit('dioClose')
  }

  private open() {
    this.$emit("update:show", true);
  }

  public loading: Boolean = false;
  private async getUpdateModel() {
    this.loading = true;
    const res: any = await getUpdateModel({
      type: this.type,
      groupInfoId: this.newSelectedRows[0].groupInfoId,
    }).then((res:any) => {
      this.table.list = res;
      this.loading = false;
    }).catch(err => {
      console.log(err);
      this.loading = false;
    });
  }

  private async submitForm(): Promise<void> {
    await this.updateModel();
  }

  // 修改号码
  private async updateModel() {
    this.$confirm("选中的行将会替换为原型号，确定要修正吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        let list = this.table.list.map((item) => {
          return {
            id: item.id,
            model: item.model,
            ids: item.ids,
          };
        });
        await updateModel(this.type, list);
        this.close();
        this.$emit("success", false);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async updateDraftDiscount(form: any) {
    if (!this.newSelectedRows.length) {
      this.$notify({
        title: "提示",
        message: "请选择产品",
        type: "error",
        duration: 2000,
      });
      return;
    }
    const proformaInvoiceInfoIds = this.newSelectedRows.map((item) => item.id);
    const { purchaseDiscount, saleDiscount } = form;
    let params = {
      proformaInvoiceInfoIds,
      purchaseDiscount: `${purchaseDiscount}%`,
      saleDiscount: `${saleDiscount}%`,
    };
    try {
      await updatePIDiscountAndProfit(params);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch (e) {
      console.log(e);
    }
  }
}
